import { ValueSet, ValuesOfImpactCategory } from '../../../../../../../common/model/input/value-sets/types';
import { keysOf } from '../../../../../../../common/utils';
import { StateHooksOfValueSetSelector } from './types';

export function getValueSetFromSelection(stateHooks: StateHooksOfValueSetSelector) {
  const valueSet = {} as ValueSet;
  const dimensions = keysOf(stateHooks);
  dimensions.forEach(d => {
    const hooksOfDimension = stateHooks[d];
    const valences = keysOf(hooksOfDimension);
    valences.forEach(v => {
      const hooksOfValence = hooksOfDimension[v].stateHooksOfImpactCategories;
      const impactCategories = keysOf(hooksOfValence);
      impactCategories.forEach(ic => {
        const [value] = hooksOfValence[ic];
        const valuesOfImpactCategory = valueSet[ic] || ({} as ValuesOfImpactCategory);
        valueSet[ic] = { ...valuesOfImpactCategory };
        valueSet[ic][v] = value;
      });
    });
  });

  return valueSet;
}
